import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from '@interstate/components/Alert';
import * as offerReduxActionCreators from '@makemydeal/dr-dash-store/actions/offerRedux';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import type { LenderChangeOrigin } from '@makemydeal/dr-offer-redux';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { RESERVE_SPLIT_CLEARED_BY_LENDER_CHANGE } from '../../constants';

export const RESERVE_SPLIT_CLEARED_ALERT_TEST_ID = 'reserve-split-cleared-alert';
export const RESERVE_SPLIT_CLEARED_ALERT_DISMISS_MS = 5000;

type Props = {
    origin: LenderChangeOrigin;
};

const ReserveSplitClearedAlert = ({ origin }: Props) => {
    const isReserveSplitOverrideEnabled = useSelector(featureToggleSelectors.isReserveSplitOverrideEnabled);
    const isClearedByLenderChange = useSelector(offerReduxSelectors.getIsReserveSplitClearedByLenderChange);
    const clearedFrom = useSelector(offerReduxSelectors.getReserveSplitClearedFrom);
    const dispatch = useDispatch();

    const isVisible = Boolean(isReserveSplitOverrideEnabled && isClearedByLenderChange && clearedFrom === origin);

    useEffect(() => {
        if (!isVisible) return undefined;
        const dismiss = () => dispatch(offerReduxActionCreators.clearReserveSplitLenderChangeMessage());
        const timeoutId = setTimeout(dismiss, RESERVE_SPLIT_CLEARED_ALERT_DISMISS_MS);
        return () => {
            clearTimeout(timeoutId);
            dismiss();
        };
    }, [isVisible, dispatch]);

    if (!isVisible) return null;

    return (
        <Alert type="info" data-testid={RESERVE_SPLIT_CLEARED_ALERT_TEST_ID} sx={{ marginTop: '0.5rem' }}>
            {RESERVE_SPLIT_CLEARED_BY_LENDER_CHANGE}
        </Alert>
    );
};

export default ReserveSplitClearedAlert;
